<template>
<el-form-item :label="form.name" :prop="form.model"
               :class="[form.options.required?'label-blue':'']"
                :rules="form.rules"
                :required="form.options.required"
                v-show="!form.options.hidden"
                style="padding-left:10px;line-height:36px;"
                >
  <el-cascader
    v-model="value[form.model]"
    :options="optionData"
    :disabled="inputDisable"
    filterable
    clearable
    style="width:226px"
    :placeholder="form.options.placeholder"
    :show-all-levels="form.options.showLast"
    :props="{ label:form.options.props.label,value:form.options.props.value,children:form.options.props.children,checkStrictly: true,emitPath:false }"
    @change="onInput"></el-cascader>
</el-form-item>
</template>

<script>
export default {
  name: 'DynamicCascader',
  // components: {},
  data () {
    return {
      loading: false,
      key: '',
      mainValue: [],
      formData: { value: '' },
      optionData: [],
      remoteSearchFunc: () => {
      }
    }
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: '',
          prop: '',
          icon: '',
          className: '',
          options: {
           defaultValue: [],
            width: "",
            placeholder: "",
            disabled: false,
            clearable: false,
            remote: true,
            remoteOptions: [],
            props: {
              value: "value",
              label: "label",
              children: "children"
            },
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true,
            showLast:false,
            remoteFunc: () => {
            },
            remoteSearch: false,
            remoteSearchFunc: () => {
            }
          },
          key: '',
          model: 'value',
          rules: [{}]
        }
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        this.mainValue = val
      }
    }
  },
  methods: {
    onInput () {
      let that = this
      this.$emit('input', that.form.model, that.mainValue)
      if (typeof that.form.options.changeFunc === 'function') {
        //that.form.options.changeFunc(that.mainValue, that, that.forms)
         that.form.options.changeFunc(that.value[that.form.model], that, that.forms)
      }
    },
    setValue (val) {
      this.mainValue = val
    },
    setList (arr) {
      this.optionData = arr
    },
    remoteMethod (query) {
      let that = this
      if (typeof that.form.options.remoteSearchFunc === 'function') {
        that.form.options.remoteSearchFunc(query, that, that.forms)
      }
    }
  },
  created () {
    let that = this
    that.key = that.form.key
    if (that.form.hasOwnProperty('options')) {
      that.value[that.form.model] = that.value[that.form.model] || that.form['options']['defaultValue'] || ''
    }
    // 下拉框数据
    if (that.form.hasOwnProperty('options')) {
      if (that.form.options.hasOwnProperty('remoteSearch')) {
        that.remoteSearchFunc = that.form['options']['remoteSearchFunc']
      }
      if (!that.form['options']['remote']) {
        if (that.form['options'].hasOwnProperty('options')) {
          that.optionData = that.form['options']['options']
        }
      } else {
        if (that.form['options'].hasOwnProperty('remoteFunc')) {
          if (typeof that.form['options']['remoteFunc'] === 'function') {
            that.form['options']['remoteFunc'](that, that.forms)
          }
        }
      }
    }
  },
  mounted () {
    let that = this
    that.$emit('init', that.key, that)
  },
  computed: {
    inputDisable () {
      return this.disabled || this.form.options.disabled
    }
  }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Form/DynamicCascader.vue"
}
</vue-filename-injector>
